import { render, staticRenderFns } from "./ParamLimit.vue?vue&type=template&id=4d7f4d21"
import script from "./ParamLimit.vue?vue&type=script&lang=js"
export * from "./ParamLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports